/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiError,
  AppointmentBaseDurationRequest,
  AppointmentGeneralMessageRequest,
  BeforeDayRequest,
  CancelHourRequest,
  CheckAdminPlanningPermissionResponse,
  CreateDayModelRequest,
  CreateTimeslotsRequest,
  CreateWeekModelRequest,
  DayModelLightResponse,
  DayModelResponse,
  DayModelResquest,
  DelegatePermissionResponse,
  GeneralPlanningSettingsResponse,
  PersonLightResponse,
  PlanningDayResponse,
  PlanningPermissionRequest,
  PlanningPermissionResponse,
  SpecialDayRequest,
  SpecialDayResponse,
  SpecificDaySinceDayModelRequest,
  TimeslotDeleteRequest,
  TimeslotRequest,
  TimeslotResponse,
  TimeslotResponsePaginated,
  TimeslotUpdatePeriodRequest,
  WeekModelByNameResponse,
  WeekModelIdsRequest,
  WeekModelRequest,
  WeekModelUpdateNameRequest,
} from '../models/index';
import {
    ApiErrorFromJSON,
    ApiErrorToJSON,
    AppointmentBaseDurationRequestFromJSON,
    AppointmentBaseDurationRequestToJSON,
    AppointmentGeneralMessageRequestFromJSON,
    AppointmentGeneralMessageRequestToJSON,
    BeforeDayRequestFromJSON,
    BeforeDayRequestToJSON,
    CancelHourRequestFromJSON,
    CancelHourRequestToJSON,
    CheckAdminPlanningPermissionResponseFromJSON,
    CheckAdminPlanningPermissionResponseToJSON,
    CreateDayModelRequestFromJSON,
    CreateDayModelRequestToJSON,
    CreateTimeslotsRequestFromJSON,
    CreateTimeslotsRequestToJSON,
    CreateWeekModelRequestFromJSON,
    CreateWeekModelRequestToJSON,
    DayModelLightResponseFromJSON,
    DayModelLightResponseToJSON,
    DayModelResponseFromJSON,
    DayModelResponseToJSON,
    DayModelResquestFromJSON,
    DayModelResquestToJSON,
    DelegatePermissionResponseFromJSON,
    DelegatePermissionResponseToJSON,
    GeneralPlanningSettingsResponseFromJSON,
    GeneralPlanningSettingsResponseToJSON,
    PersonLightResponseFromJSON,
    PersonLightResponseToJSON,
    PlanningDayResponseFromJSON,
    PlanningDayResponseToJSON,
    PlanningPermissionRequestFromJSON,
    PlanningPermissionRequestToJSON,
    PlanningPermissionResponseFromJSON,
    PlanningPermissionResponseToJSON,
    SpecialDayRequestFromJSON,
    SpecialDayRequestToJSON,
    SpecialDayResponseFromJSON,
    SpecialDayResponseToJSON,
    SpecificDaySinceDayModelRequestFromJSON,
    SpecificDaySinceDayModelRequestToJSON,
    TimeslotDeleteRequestFromJSON,
    TimeslotDeleteRequestToJSON,
    TimeslotRequestFromJSON,
    TimeslotRequestToJSON,
    TimeslotResponseFromJSON,
    TimeslotResponseToJSON,
    TimeslotResponsePaginatedFromJSON,
    TimeslotResponsePaginatedToJSON,
    TimeslotUpdatePeriodRequestFromJSON,
    TimeslotUpdatePeriodRequestToJSON,
    WeekModelByNameResponseFromJSON,
    WeekModelByNameResponseToJSON,
    WeekModelIdsRequestFromJSON,
    WeekModelIdsRequestToJSON,
    WeekModelRequestFromJSON,
    WeekModelRequestToJSON,
    WeekModelUpdateNameRequestFromJSON,
    WeekModelUpdateNameRequestToJSON,
} from '../models/index';

export interface AddSpecificDaySinceNewDayModelRequest {
    instituteId: string;
    specificDaySinceDayModelRequest: SpecificDaySinceDayModelRequest;
    doctorId?: string;
    date?: string;
}

export interface AddTimeslotsRequest {
    instituteId: string;
    createTimeslotsRequest: CreateTimeslotsRequest;
    doctorId?: string;
}

export interface AddUpdateSlotDayModelByIdRequest {
    instituteId: string;
    daymodelId: string;
    appointmentTypeId: string;
    timeslotRequest: TimeslotRequest;
}

export interface AddWeekModelByInstituteRequest {
    instituteId: string;
    createWeekModelRequest: CreateWeekModelRequest;
    doctorId?: string;
}

export interface CheckHealthProForAdminPlanningPermissionForHealthProRequest {
    instituteId: string;
    personId: string;
}

export interface CreateDayModelByInstituteRequest {
    instituteId: string;
    createDayModelRequest: CreateDayModelRequest;
    doctorId?: string;
}

export interface CreateSpecialDayForInstituteRequest {
    instituteId: string;
    specialDayRequest: SpecialDayRequest;
    doctorId?: string;
}

export interface DeleteDayModelRequest {
    instituteId: string;
    daymodelId: string;
}

export interface DeleteSpecialDayForInstituteRequest {
    instituteId: string;
    specialdayId: string;
}

export interface DeleteTimeslotByIdRequest {
    instituteId: string;
    timeslotId: string;
    doctorId?: string;
}

export interface DeleteTimeslotDayModelByIdRequest {
    instituteId: string;
    daymodelId: string;
    timeslotId: string;
}

export interface DeleteTimeslotsByIdsRequest {
    instituteId: string;
    timeslotDeleteRequest: TimeslotDeleteRequest;
    doctorId?: string;
}

export interface DeleteWeekModelByInstituteRequest {
    instituteId: string;
    weekModelIdsRequest: WeekModelIdsRequest;
    doctorId?: string;
}

export interface FindDayModelByInstituteRequest {
    instituteId: string;
    doctorId?: string;
}

export interface FindSpecialDaysByInstituteRequest {
    instituteId: string;
    doctorId?: string;
}

export interface FindTimeslotsByInstituteRequest {
    instituteId: string;
    doctorId?: string;
    start?: number;
    limit?: number;
}

export interface FindWeekModelByInstituteRequest {
    instituteId: string;
    doctorId?: string;
}

export interface GetDayModelByDateRequest {
    instituteId: string;
    doctorId?: string;
    date?: string;
}

export interface GetDayModelByIdRequest {
    instituteId: string;
    daymodelId: string;
    appointmentTypeId: string;
    doctorId?: string;
}

export interface GetDelegatePermissionsByInstituteRequest {
    instituteId: string;
}

export interface GetGeneralPlanningSettingsByInstituteRequest {
    instituteId: string;
    doctorId: string;
}

export interface GetHealthProForAdminPlanningByInstituteRequest {
    instituteId: string;
}

export interface GetPlanningPermissionsByInstituteRequest {
    instituteId: string;
    doctorId: string;
}

export interface ListDaysPlanningRequest {
    instituteId: string;
    filterActive?: boolean;
}

export interface SetAppointmentBaseDurationByInstituteRequest {
    instituteId: string;
    doctorId: string;
    appointmentBaseDurationRequest: AppointmentBaseDurationRequest;
}

export interface SetAppointmentGeneralMessageByInstituteRequest {
    instituteId: string;
    doctorId: string;
    appointmentGeneralMessageRequest: AppointmentGeneralMessageRequest;
}

export interface SetBeforeDayByInstituteRequest {
    instituteId: string;
    doctorId: string;
    beforeDayRequest: BeforeDayRequest;
}

export interface SetCancelHourByInstituteRequest {
    instituteId: string;
    doctorId: string;
    cancelHourRequest: CancelHourRequest;
}

export interface UpdateDayModelRequest {
    instituteId: string;
    daymodelId: string;
    dayModelResquest: DayModelResquest;
}

export interface UpdateDayPlanningRequest {
    instituteId: string;
    dayPlanningId: string;
}

export interface UpdateDelegatePermissionsRequest {
    instituteId: string;
    delegatePermId: string;
}

export interface UpdatePeriodTimeslotByIdRequest {
    instituteId: string;
    timeslotId: string;
    timeslotUpdatePeriodRequest: TimeslotUpdatePeriodRequest;
    doctorId?: string;
}

export interface UpdatePlanningPermissionRequest {
    instituteId: string;
    planningPermissionId: string;
    planningPermissionRequest: PlanningPermissionRequest;
}

export interface UpdateSpecialDayForInstituteRequest {
    instituteId: string;
    specialdayId: string;
    specialDayRequest: SpecialDayRequest;
}

export interface UpdateSpecificDaySinceNewDayModelRequest {
    instituteId: string;
    daymodelId: string;
    specificDaySinceDayModelRequest: SpecificDaySinceDayModelRequest;
}

export interface UpdateWeekModelRequest {
    instituteId: string;
    weekmodelId: string;
    weekModelRequest: WeekModelRequest;
}

export interface UpdateWeekModelTimeslotByIdRequest {
    instituteId: string;
    timeslotId: string;
    weekModelIdsRequest: WeekModelIdsRequest;
    doctorId?: string;
}

export interface UpdateWeekModelsNameRequest {
    instituteId: string;
    weekModelUpdateNameRequest: WeekModelUpdateNameRequest;
    doctorId?: string;
}

/**
 * 
 */
export class SettingsApi extends runtime.BaseAPI {

    /**
     * Add a specific days since new day model
     */
    async addSpecificDaySinceNewDayModelRaw(requestParameters: AddSpecificDaySinceNewDayModelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DayModelResponse>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling addSpecificDaySinceNewDayModel().'
            );
        }

        if (requestParameters['specificDaySinceDayModelRequest'] == null) {
            throw new runtime.RequiredError(
                'specificDaySinceDayModelRequest',
                'Required parameter "specificDaySinceDayModelRequest" was null or undefined when calling addSpecificDaySinceNewDayModel().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['doctorId'] != null) {
            queryParameters['doctor_id'] = requestParameters['doctorId'];
        }

        if (requestParameters['date'] != null) {
            queryParameters['date'] = requestParameters['date'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/settings/day-model-by-date`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SpecificDaySinceDayModelRequestToJSON(requestParameters['specificDaySinceDayModelRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DayModelResponseFromJSON(jsonValue));
    }

    /**
     * Add a specific days since new day model
     */
    async addSpecificDaySinceNewDayModel(requestParameters: AddSpecificDaySinceNewDayModelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DayModelResponse> {
        const response = await this.addSpecificDaySinceNewDayModelRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Add a timeslot for a specific user and institute
     */
    async addTimeslotsRaw(requestParameters: AddTimeslotsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TimeslotResponsePaginated>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling addTimeslots().'
            );
        }

        if (requestParameters['createTimeslotsRequest'] == null) {
            throw new runtime.RequiredError(
                'createTimeslotsRequest',
                'Required parameter "createTimeslotsRequest" was null or undefined when calling addTimeslots().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['doctorId'] != null) {
            queryParameters['doctor_id'] = requestParameters['doctorId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/settings/timeslots`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateTimeslotsRequestToJSON(requestParameters['createTimeslotsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TimeslotResponsePaginatedFromJSON(jsonValue));
    }

    /**
     * Add a timeslot for a specific user and institute
     */
    async addTimeslots(requestParameters: AddTimeslotsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TimeslotResponsePaginated> {
        const response = await this.addTimeslotsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * add or update slot in day model by id
     */
    async addUpdateSlotDayModelByIdRaw(requestParameters: AddUpdateSlotDayModelByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling addUpdateSlotDayModelById().'
            );
        }

        if (requestParameters['daymodelId'] == null) {
            throw new runtime.RequiredError(
                'daymodelId',
                'Required parameter "daymodelId" was null or undefined when calling addUpdateSlotDayModelById().'
            );
        }

        if (requestParameters['appointmentTypeId'] == null) {
            throw new runtime.RequiredError(
                'appointmentTypeId',
                'Required parameter "appointmentTypeId" was null or undefined when calling addUpdateSlotDayModelById().'
            );
        }

        if (requestParameters['timeslotRequest'] == null) {
            throw new runtime.RequiredError(
                'timeslotRequest',
                'Required parameter "timeslotRequest" was null or undefined when calling addUpdateSlotDayModelById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['appointmentTypeId'] != null) {
            queryParameters['appointmentType_id'] = requestParameters['appointmentTypeId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/settings/day-model/{daymodel_id}/slots`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))).replace(`{${"daymodel_id"}}`, encodeURIComponent(String(requestParameters['daymodelId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: TimeslotRequestToJSON(requestParameters['timeslotRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * add or update slot in day model by id
     */
    async addUpdateSlotDayModelById(requestParameters: AddUpdateSlotDayModelByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.addUpdateSlotDayModelByIdRaw(requestParameters, initOverrides);
    }

    /**
     * Create week model by institute for a doctor
     */
    async addWeekModelByInstituteRaw(requestParameters: AddWeekModelByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WeekModelByNameResponse>>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling addWeekModelByInstitute().'
            );
        }

        if (requestParameters['createWeekModelRequest'] == null) {
            throw new runtime.RequiredError(
                'createWeekModelRequest',
                'Required parameter "createWeekModelRequest" was null or undefined when calling addWeekModelByInstitute().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['doctorId'] != null) {
            queryParameters['doctor_id'] = requestParameters['doctorId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/settings/week-model`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateWeekModelRequestToJSON(requestParameters['createWeekModelRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WeekModelByNameResponseFromJSON));
    }

    /**
     * Create week model by institute for a doctor
     */
    async addWeekModelByInstitute(requestParameters: AddWeekModelByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WeekModelByNameResponse>> {
        const response = await this.addWeekModelByInstituteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Check current user has admin planning permission for a healthPro
     */
    async checkHealthProForAdminPlanningPermissionForHealthProRaw(requestParameters: CheckHealthProForAdminPlanningPermissionForHealthProRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CheckAdminPlanningPermissionResponse>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling checkHealthProForAdminPlanningPermissionForHealthPro().'
            );
        }

        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling checkHealthProForAdminPlanningPermissionForHealthPro().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/settings/planning/health-pro/{person_id}`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))).replace(`{${"person_id"}}`, encodeURIComponent(String(requestParameters['personId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CheckAdminPlanningPermissionResponseFromJSON(jsonValue));
    }

    /**
     * Check current user has admin planning permission for a healthPro
     */
    async checkHealthProForAdminPlanningPermissionForHealthPro(requestParameters: CheckHealthProForAdminPlanningPermissionForHealthProRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CheckAdminPlanningPermissionResponse> {
        const response = await this.checkHealthProForAdminPlanningPermissionForHealthProRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create day model by institute for connected user
     */
    async createDayModelByInstituteRaw(requestParameters: CreateDayModelByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DayModelLightResponse>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling createDayModelByInstitute().'
            );
        }

        if (requestParameters['createDayModelRequest'] == null) {
            throw new runtime.RequiredError(
                'createDayModelRequest',
                'Required parameter "createDayModelRequest" was null or undefined when calling createDayModelByInstitute().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['doctorId'] != null) {
            queryParameters['doctor_id'] = requestParameters['doctorId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/settings/day-model`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateDayModelRequestToJSON(requestParameters['createDayModelRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DayModelLightResponseFromJSON(jsonValue));
    }

    /**
     * Create day model by institute for connected user
     */
    async createDayModelByInstitute(requestParameters: CreateDayModelByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DayModelLightResponse> {
        const response = await this.createDayModelByInstituteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create special day for connected user in selected institute at selected date
     */
    async createSpecialDayForInstituteRaw(requestParameters: CreateSpecialDayForInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SpecialDayResponse>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling createSpecialDayForInstitute().'
            );
        }

        if (requestParameters['specialDayRequest'] == null) {
            throw new runtime.RequiredError(
                'specialDayRequest',
                'Required parameter "specialDayRequest" was null or undefined when calling createSpecialDayForInstitute().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['doctorId'] != null) {
            queryParameters['doctor_id'] = requestParameters['doctorId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/settings/special-day`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SpecialDayRequestToJSON(requestParameters['specialDayRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SpecialDayResponseFromJSON(jsonValue));
    }

    /**
     * Create special day for connected user in selected institute at selected date
     */
    async createSpecialDayForInstitute(requestParameters: CreateSpecialDayForInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SpecialDayResponse> {
        const response = await this.createSpecialDayForInstituteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete daymodel
     */
    async deleteDayModelRaw(requestParameters: DeleteDayModelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DayModelLightResponse>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling deleteDayModel().'
            );
        }

        if (requestParameters['daymodelId'] == null) {
            throw new runtime.RequiredError(
                'daymodelId',
                'Required parameter "daymodelId" was null or undefined when calling deleteDayModel().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/settings/day-model/{daymodel_id}`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))).replace(`{${"daymodel_id"}}`, encodeURIComponent(String(requestParameters['daymodelId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DayModelLightResponseFromJSON(jsonValue));
    }

    /**
     * Delete daymodel
     */
    async deleteDayModel(requestParameters: DeleteDayModelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DayModelLightResponse> {
        const response = await this.deleteDayModelRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update special day for connected user in selected institute at selected date
     */
    async deleteSpecialDayForInstituteRaw(requestParameters: DeleteSpecialDayForInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling deleteSpecialDayForInstitute().'
            );
        }

        if (requestParameters['specialdayId'] == null) {
            throw new runtime.RequiredError(
                'specialdayId',
                'Required parameter "specialdayId" was null or undefined when calling deleteSpecialDayForInstitute().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/settings/special-day/{specialday_id}`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))).replace(`{${"specialday_id"}}`, encodeURIComponent(String(requestParameters['specialdayId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update special day for connected user in selected institute at selected date
     */
    async deleteSpecialDayForInstitute(requestParameters: DeleteSpecialDayForInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteSpecialDayForInstituteRaw(requestParameters, initOverrides);
    }

    /**
     * Delete timeslot by id
     */
    async deleteTimeslotByIdRaw(requestParameters: DeleteTimeslotByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling deleteTimeslotById().'
            );
        }

        if (requestParameters['timeslotId'] == null) {
            throw new runtime.RequiredError(
                'timeslotId',
                'Required parameter "timeslotId" was null or undefined when calling deleteTimeslotById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['doctorId'] != null) {
            queryParameters['doctor_id'] = requestParameters['doctorId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/settings/timeslots/{timeslot_id}`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))).replace(`{${"timeslot_id"}}`, encodeURIComponent(String(requestParameters['timeslotId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete timeslot by id
     */
    async deleteTimeslotById(requestParameters: DeleteTimeslotByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteTimeslotByIdRaw(requestParameters, initOverrides);
    }

    /**
     * Delete timeslot of day model by id
     */
    async deleteTimeslotDayModelByIdRaw(requestParameters: DeleteTimeslotDayModelByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling deleteTimeslotDayModelById().'
            );
        }

        if (requestParameters['daymodelId'] == null) {
            throw new runtime.RequiredError(
                'daymodelId',
                'Required parameter "daymodelId" was null or undefined when calling deleteTimeslotDayModelById().'
            );
        }

        if (requestParameters['timeslotId'] == null) {
            throw new runtime.RequiredError(
                'timeslotId',
                'Required parameter "timeslotId" was null or undefined when calling deleteTimeslotDayModelById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/settings/day-model/{daymodel_id}/slots/{timeslot_id}`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))).replace(`{${"daymodel_id"}}`, encodeURIComponent(String(requestParameters['daymodelId']))).replace(`{${"timeslot_id"}}`, encodeURIComponent(String(requestParameters['timeslotId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete timeslot of day model by id
     */
    async deleteTimeslotDayModelById(requestParameters: DeleteTimeslotDayModelByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteTimeslotDayModelByIdRaw(requestParameters, initOverrides);
    }

    /**
     * Delete several timeslot by id
     */
    async deleteTimeslotsByIdsRaw(requestParameters: DeleteTimeslotsByIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling deleteTimeslotsByIds().'
            );
        }

        if (requestParameters['timeslotDeleteRequest'] == null) {
            throw new runtime.RequiredError(
                'timeslotDeleteRequest',
                'Required parameter "timeslotDeleteRequest" was null or undefined when calling deleteTimeslotsByIds().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['doctorId'] != null) {
            queryParameters['doctor_id'] = requestParameters['doctorId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/settings/timeslots`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: TimeslotDeleteRequestToJSON(requestParameters['timeslotDeleteRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete several timeslot by id
     */
    async deleteTimeslotsByIds(requestParameters: DeleteTimeslotsByIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteTimeslotsByIdsRaw(requestParameters, initOverrides);
    }

    /**
     * Get week model by institute for a doctor
     */
    async deleteWeekModelByInstituteRaw(requestParameters: DeleteWeekModelByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling deleteWeekModelByInstitute().'
            );
        }

        if (requestParameters['weekModelIdsRequest'] == null) {
            throw new runtime.RequiredError(
                'weekModelIdsRequest',
                'Required parameter "weekModelIdsRequest" was null or undefined when calling deleteWeekModelByInstitute().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['doctorId'] != null) {
            queryParameters['doctor_id'] = requestParameters['doctorId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/settings/week-model`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: WeekModelIdsRequestToJSON(requestParameters['weekModelIdsRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Get week model by institute for a doctor
     */
    async deleteWeekModelByInstitute(requestParameters: DeleteWeekModelByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteWeekModelByInstituteRaw(requestParameters, initOverrides);
    }

    /**
     * Get day model by institute for specific user
     */
    async findDayModelByInstituteRaw(requestParameters: FindDayModelByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DayModelLightResponse>>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling findDayModelByInstitute().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['doctorId'] != null) {
            queryParameters['doctor_id'] = requestParameters['doctorId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/settings/day-model`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DayModelLightResponseFromJSON));
    }

    /**
     * Get day model by institute for specific user
     */
    async findDayModelByInstitute(requestParameters: FindDayModelByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DayModelLightResponse>> {
        const response = await this.findDayModelByInstituteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get special days by institute for connected user
     */
    async findSpecialDaysByInstituteRaw(requestParameters: FindSpecialDaysByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SpecialDayResponse>>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling findSpecialDaysByInstitute().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['doctorId'] != null) {
            queryParameters['doctor_id'] = requestParameters['doctorId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/settings/special-day`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SpecialDayResponseFromJSON));
    }

    /**
     * Get special days by institute for connected user
     */
    async findSpecialDaysByInstitute(requestParameters: FindSpecialDaysByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SpecialDayResponse>> {
        const response = await this.findSpecialDaysByInstituteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get timeslots by institute for specific user
     */
    async findTimeslotsByInstituteRaw(requestParameters: FindTimeslotsByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TimeslotResponsePaginated>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling findTimeslotsByInstitute().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['doctorId'] != null) {
            queryParameters['doctor_id'] = requestParameters['doctorId'];
        }

        if (requestParameters['start'] != null) {
            queryParameters['start'] = requestParameters['start'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/settings/timeslots`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TimeslotResponsePaginatedFromJSON(jsonValue));
    }

    /**
     * Get timeslots by institute for specific user
     */
    async findTimeslotsByInstitute(requestParameters: FindTimeslotsByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TimeslotResponsePaginated> {
        const response = await this.findTimeslotsByInstituteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get week model by institute for a doctor
     */
    async findWeekModelByInstituteRaw(requestParameters: FindWeekModelByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WeekModelByNameResponse>>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling findWeekModelByInstitute().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['doctorId'] != null) {
            queryParameters['doctor_id'] = requestParameters['doctorId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/settings/week-model`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WeekModelByNameResponseFromJSON));
    }

    /**
     * Get week model by institute for a doctor
     */
    async findWeekModelByInstitute(requestParameters: FindWeekModelByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WeekModelByNameResponse>> {
        const response = await this.findWeekModelByInstituteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get day model by institute for specific user and specific date
     */
    async getDayModelByDateRaw(requestParameters: GetDayModelByDateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DayModelResponse>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling getDayModelByDate().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['doctorId'] != null) {
            queryParameters['doctor_id'] = requestParameters['doctorId'];
        }

        if (requestParameters['date'] != null) {
            queryParameters['date'] = requestParameters['date'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/settings/day-model-by-date`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DayModelResponseFromJSON(jsonValue));
    }

    /**
     * Get day model by institute for specific user and specific date
     */
    async getDayModelByDate(requestParameters: GetDayModelByDateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DayModelResponse> {
        const response = await this.getDayModelByDateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get day model by id
     */
    async getDayModelByIdRaw(requestParameters: GetDayModelByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DayModelResponse>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling getDayModelById().'
            );
        }

        if (requestParameters['daymodelId'] == null) {
            throw new runtime.RequiredError(
                'daymodelId',
                'Required parameter "daymodelId" was null or undefined when calling getDayModelById().'
            );
        }

        if (requestParameters['appointmentTypeId'] == null) {
            throw new runtime.RequiredError(
                'appointmentTypeId',
                'Required parameter "appointmentTypeId" was null or undefined when calling getDayModelById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['appointmentTypeId'] != null) {
            queryParameters['appointmentType_id'] = requestParameters['appointmentTypeId'];
        }

        if (requestParameters['doctorId'] != null) {
            queryParameters['doctor_id'] = requestParameters['doctorId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/settings/day-model/{daymodel_id}`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))).replace(`{${"daymodel_id"}}`, encodeURIComponent(String(requestParameters['daymodelId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DayModelResponseFromJSON(jsonValue));
    }

    /**
     * Get day model by id
     */
    async getDayModelById(requestParameters: GetDayModelByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DayModelResponse> {
        const response = await this.getDayModelByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get health assistants with permission to manage patient
     */
    async getDelegatePermissionsByInstituteRaw(requestParameters: GetDelegatePermissionsByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DelegatePermissionResponse>>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling getDelegatePermissionsByInstitute().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/settings/patients/delegate-permissions`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DelegatePermissionResponseFromJSON));
    }

    /**
     * Get health assistants with permission to manage patient
     */
    async getDelegatePermissionsByInstitute(requestParameters: GetDelegatePermissionsByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DelegatePermissionResponse>> {
        const response = await this.getDelegatePermissionsByInstituteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get general planning settings by institute for connected user
     */
    async getGeneralPlanningSettingsByInstituteRaw(requestParameters: GetGeneralPlanningSettingsByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GeneralPlanningSettingsResponse>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling getGeneralPlanningSettingsByInstitute().'
            );
        }

        if (requestParameters['doctorId'] == null) {
            throw new runtime.RequiredError(
                'doctorId',
                'Required parameter "doctorId" was null or undefined when calling getGeneralPlanningSettingsByInstitute().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['doctorId'] != null) {
            queryParameters['doctor_id'] = requestParameters['doctorId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/settings/planning-general`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GeneralPlanningSettingsResponseFromJSON(jsonValue));
    }

    /**
     * Get general planning settings by institute for connected user
     */
    async getGeneralPlanningSettingsByInstitute(requestParameters: GetGeneralPlanningSettingsByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GeneralPlanningSettingsResponse> {
        const response = await this.getGeneralPlanningSettingsByInstituteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get list of healthPro for admin planning
     */
    async getHealthProForAdminPlanningByInstituteRaw(requestParameters: GetHealthProForAdminPlanningByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PersonLightResponse>>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling getHealthProForAdminPlanningByInstitute().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/settings/planning/health-pro`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PersonLightResponseFromJSON));
    }

    /**
     * Get list of healthPro for admin planning
     */
    async getHealthProForAdminPlanningByInstitute(requestParameters: GetHealthProForAdminPlanningByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PersonLightResponse>> {
        const response = await this.getHealthProForAdminPlanningByInstituteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get medical person with access calendar permission
     */
    async getPlanningPermissionsByInstituteRaw(requestParameters: GetPlanningPermissionsByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PlanningPermissionResponse>>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling getPlanningPermissionsByInstitute().'
            );
        }

        if (requestParameters['doctorId'] == null) {
            throw new runtime.RequiredError(
                'doctorId',
                'Required parameter "doctorId" was null or undefined when calling getPlanningPermissionsByInstitute().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['doctorId'] != null) {
            queryParameters['doctor_id'] = requestParameters['doctorId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/settings/planning/permissions`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PlanningPermissionResponseFromJSON));
    }

    /**
     * Get medical person with access calendar permission
     */
    async getPlanningPermissionsByInstitute(requestParameters: GetPlanningPermissionsByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PlanningPermissionResponse>> {
        const response = await this.getPlanningPermissionsByInstituteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all day to display or not for an institute
     */
    async listDaysPlanningRaw(requestParameters: ListDaysPlanningRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PlanningDayResponse>>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling listDaysPlanning().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterActive'] != null) {
            queryParameters['filterActive'] = requestParameters['filterActive'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/settings/days-planning`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PlanningDayResponseFromJSON));
    }

    /**
     * List all day to display or not for an institute
     */
    async listDaysPlanning(requestParameters: ListDaysPlanningRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PlanningDayResponse>> {
        const response = await this.listDaysPlanningRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Sets the base unit of time for appointments
     */
    async setAppointmentBaseDurationByInstituteRaw(requestParameters: SetAppointmentBaseDurationByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GeneralPlanningSettingsResponse>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling setAppointmentBaseDurationByInstitute().'
            );
        }

        if (requestParameters['doctorId'] == null) {
            throw new runtime.RequiredError(
                'doctorId',
                'Required parameter "doctorId" was null or undefined when calling setAppointmentBaseDurationByInstitute().'
            );
        }

        if (requestParameters['appointmentBaseDurationRequest'] == null) {
            throw new runtime.RequiredError(
                'appointmentBaseDurationRequest',
                'Required parameter "appointmentBaseDurationRequest" was null or undefined when calling setAppointmentBaseDurationByInstitute().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['doctorId'] != null) {
            queryParameters['doctor_id'] = requestParameters['doctorId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/settings/planning-general/appointment-base-duration`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AppointmentBaseDurationRequestToJSON(requestParameters['appointmentBaseDurationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GeneralPlanningSettingsResponseFromJSON(jsonValue));
    }

    /**
     * Sets the base unit of time for appointments
     */
    async setAppointmentBaseDurationByInstitute(requestParameters: SetAppointmentBaseDurationByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GeneralPlanningSettingsResponse> {
        const response = await this.setAppointmentBaseDurationByInstituteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Set the appointments general message
     */
    async setAppointmentGeneralMessageByInstituteRaw(requestParameters: SetAppointmentGeneralMessageByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GeneralPlanningSettingsResponse>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling setAppointmentGeneralMessageByInstitute().'
            );
        }

        if (requestParameters['doctorId'] == null) {
            throw new runtime.RequiredError(
                'doctorId',
                'Required parameter "doctorId" was null or undefined when calling setAppointmentGeneralMessageByInstitute().'
            );
        }

        if (requestParameters['appointmentGeneralMessageRequest'] == null) {
            throw new runtime.RequiredError(
                'appointmentGeneralMessageRequest',
                'Required parameter "appointmentGeneralMessageRequest" was null or undefined when calling setAppointmentGeneralMessageByInstitute().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['doctorId'] != null) {
            queryParameters['doctor_id'] = requestParameters['doctorId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/settings/planning-general/appointment-general-message`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AppointmentGeneralMessageRequestToJSON(requestParameters['appointmentGeneralMessageRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GeneralPlanningSettingsResponseFromJSON(jsonValue));
    }

    /**
     * Set the appointments general message
     */
    async setAppointmentGeneralMessageByInstitute(requestParameters: SetAppointmentGeneralMessageByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GeneralPlanningSettingsResponse> {
        const response = await this.setAppointmentGeneralMessageByInstituteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Set the number of days before an appointment can be reserved
     */
    async setBeforeDayByInstituteRaw(requestParameters: SetBeforeDayByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GeneralPlanningSettingsResponse>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling setBeforeDayByInstitute().'
            );
        }

        if (requestParameters['doctorId'] == null) {
            throw new runtime.RequiredError(
                'doctorId',
                'Required parameter "doctorId" was null or undefined when calling setBeforeDayByInstitute().'
            );
        }

        if (requestParameters['beforeDayRequest'] == null) {
            throw new runtime.RequiredError(
                'beforeDayRequest',
                'Required parameter "beforeDayRequest" was null or undefined when calling setBeforeDayByInstitute().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['doctorId'] != null) {
            queryParameters['doctor_id'] = requestParameters['doctorId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/settings/planning-general/before-day`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: BeforeDayRequestToJSON(requestParameters['beforeDayRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GeneralPlanningSettingsResponseFromJSON(jsonValue));
    }

    /**
     * Set the number of days before an appointment can be reserved
     */
    async setBeforeDayByInstitute(requestParameters: SetBeforeDayByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GeneralPlanningSettingsResponse> {
        const response = await this.setBeforeDayByInstituteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Set the number of hour before an appointment can be cancelled
     */
    async setCancelHourByInstituteRaw(requestParameters: SetCancelHourByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GeneralPlanningSettingsResponse>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling setCancelHourByInstitute().'
            );
        }

        if (requestParameters['doctorId'] == null) {
            throw new runtime.RequiredError(
                'doctorId',
                'Required parameter "doctorId" was null or undefined when calling setCancelHourByInstitute().'
            );
        }

        if (requestParameters['cancelHourRequest'] == null) {
            throw new runtime.RequiredError(
                'cancelHourRequest',
                'Required parameter "cancelHourRequest" was null or undefined when calling setCancelHourByInstitute().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['doctorId'] != null) {
            queryParameters['doctor_id'] = requestParameters['doctorId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/settings/planning-general/cancel-hour`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CancelHourRequestToJSON(requestParameters['cancelHourRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GeneralPlanningSettingsResponseFromJSON(jsonValue));
    }

    /**
     * Set the number of hour before an appointment can be cancelled
     */
    async setCancelHourByInstitute(requestParameters: SetCancelHourByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GeneralPlanningSettingsResponse> {
        const response = await this.setCancelHourByInstituteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update daymodel name
     */
    async updateDayModelRaw(requestParameters: UpdateDayModelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DayModelLightResponse>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling updateDayModel().'
            );
        }

        if (requestParameters['daymodelId'] == null) {
            throw new runtime.RequiredError(
                'daymodelId',
                'Required parameter "daymodelId" was null or undefined when calling updateDayModel().'
            );
        }

        if (requestParameters['dayModelResquest'] == null) {
            throw new runtime.RequiredError(
                'dayModelResquest',
                'Required parameter "dayModelResquest" was null or undefined when calling updateDayModel().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/settings/day-model/{daymodel_id}`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))).replace(`{${"daymodel_id"}}`, encodeURIComponent(String(requestParameters['daymodelId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DayModelResquestToJSON(requestParameters['dayModelResquest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DayModelLightResponseFromJSON(jsonValue));
    }

    /**
     * Update daymodel name
     */
    async updateDayModel(requestParameters: UpdateDayModelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DayModelLightResponse> {
        const response = await this.updateDayModelRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update the active value of a day planning
     */
    async updateDayPlanningRaw(requestParameters: UpdateDayPlanningRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PlanningDayResponse>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling updateDayPlanning().'
            );
        }

        if (requestParameters['dayPlanningId'] == null) {
            throw new runtime.RequiredError(
                'dayPlanningId',
                'Required parameter "dayPlanningId" was null or undefined when calling updateDayPlanning().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/settings/days-planning/{day_planning_id}`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))).replace(`{${"day_planning_id"}}`, encodeURIComponent(String(requestParameters['dayPlanningId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PlanningDayResponseFromJSON(jsonValue));
    }

    /**
     * Update the active value of a day planning
     */
    async updateDayPlanning(requestParameters: UpdateDayPlanningRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PlanningDayResponse> {
        const response = await this.updateDayPlanningRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update access permission to manage patient for a health assistants
     */
    async updateDelegatePermissionsRaw(requestParameters: UpdateDelegatePermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DelegatePermissionResponse>>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling updateDelegatePermissions().'
            );
        }

        if (requestParameters['delegatePermId'] == null) {
            throw new runtime.RequiredError(
                'delegatePermId',
                'Required parameter "delegatePermId" was null or undefined when calling updateDelegatePermissions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/settings/patients/delegate-permissions/{delegate_perm_id}`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))).replace(`{${"delegate_perm_id"}}`, encodeURIComponent(String(requestParameters['delegatePermId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DelegatePermissionResponseFromJSON));
    }

    /**
     * Update access permission to manage patient for a health assistants
     */
    async updateDelegatePermissions(requestParameters: UpdateDelegatePermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DelegatePermissionResponse>> {
        const response = await this.updateDelegatePermissionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update period of timeslot by id
     */
    async updatePeriodTimeslotByIdRaw(requestParameters: UpdatePeriodTimeslotByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TimeslotResponse>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling updatePeriodTimeslotById().'
            );
        }

        if (requestParameters['timeslotId'] == null) {
            throw new runtime.RequiredError(
                'timeslotId',
                'Required parameter "timeslotId" was null or undefined when calling updatePeriodTimeslotById().'
            );
        }

        if (requestParameters['timeslotUpdatePeriodRequest'] == null) {
            throw new runtime.RequiredError(
                'timeslotUpdatePeriodRequest',
                'Required parameter "timeslotUpdatePeriodRequest" was null or undefined when calling updatePeriodTimeslotById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['doctorId'] != null) {
            queryParameters['doctor_id'] = requestParameters['doctorId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/settings/timeslots/{timeslot_id}`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))).replace(`{${"timeslot_id"}}`, encodeURIComponent(String(requestParameters['timeslotId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: TimeslotUpdatePeriodRequestToJSON(requestParameters['timeslotUpdatePeriodRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TimeslotResponseFromJSON(jsonValue));
    }

    /**
     * Update period of timeslot by id
     */
    async updatePeriodTimeslotById(requestParameters: UpdatePeriodTimeslotByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TimeslotResponse> {
        const response = await this.updatePeriodTimeslotByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an calendar access at a medical person
     */
    async updatePlanningPermissionRaw(requestParameters: UpdatePlanningPermissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PlanningPermissionResponse>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling updatePlanningPermission().'
            );
        }

        if (requestParameters['planningPermissionId'] == null) {
            throw new runtime.RequiredError(
                'planningPermissionId',
                'Required parameter "planningPermissionId" was null or undefined when calling updatePlanningPermission().'
            );
        }

        if (requestParameters['planningPermissionRequest'] == null) {
            throw new runtime.RequiredError(
                'planningPermissionRequest',
                'Required parameter "planningPermissionRequest" was null or undefined when calling updatePlanningPermission().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/settings/planning/permissions/{planning_permission_id}`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))).replace(`{${"planning_permission_id"}}`, encodeURIComponent(String(requestParameters['planningPermissionId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PlanningPermissionRequestToJSON(requestParameters['planningPermissionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PlanningPermissionResponseFromJSON(jsonValue));
    }

    /**
     * Update an calendar access at a medical person
     */
    async updatePlanningPermission(requestParameters: UpdatePlanningPermissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PlanningPermissionResponse> {
        const response = await this.updatePlanningPermissionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update special day for connected user in selected institute at selected date
     */
    async updateSpecialDayForInstituteRaw(requestParameters: UpdateSpecialDayForInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SpecialDayResponse>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling updateSpecialDayForInstitute().'
            );
        }

        if (requestParameters['specialdayId'] == null) {
            throw new runtime.RequiredError(
                'specialdayId',
                'Required parameter "specialdayId" was null or undefined when calling updateSpecialDayForInstitute().'
            );
        }

        if (requestParameters['specialDayRequest'] == null) {
            throw new runtime.RequiredError(
                'specialDayRequest',
                'Required parameter "specialDayRequest" was null or undefined when calling updateSpecialDayForInstitute().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/settings/special-day/{specialday_id}`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))).replace(`{${"specialday_id"}}`, encodeURIComponent(String(requestParameters['specialdayId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SpecialDayRequestToJSON(requestParameters['specialDayRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SpecialDayResponseFromJSON(jsonValue));
    }

    /**
     * Update special day for connected user in selected institute at selected date
     */
    async updateSpecialDayForInstitute(requestParameters: UpdateSpecialDayForInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SpecialDayResponse> {
        const response = await this.updateSpecialDayForInstituteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a specific days since new day model
     */
    async updateSpecificDaySinceNewDayModelRaw(requestParameters: UpdateSpecificDaySinceNewDayModelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DayModelResponse>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling updateSpecificDaySinceNewDayModel().'
            );
        }

        if (requestParameters['daymodelId'] == null) {
            throw new runtime.RequiredError(
                'daymodelId',
                'Required parameter "daymodelId" was null or undefined when calling updateSpecificDaySinceNewDayModel().'
            );
        }

        if (requestParameters['specificDaySinceDayModelRequest'] == null) {
            throw new runtime.RequiredError(
                'specificDaySinceDayModelRequest',
                'Required parameter "specificDaySinceDayModelRequest" was null or undefined when calling updateSpecificDaySinceNewDayModel().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/settings/day-model-by-date/{daymodel_id}`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))).replace(`{${"daymodel_id"}}`, encodeURIComponent(String(requestParameters['daymodelId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SpecificDaySinceDayModelRequestToJSON(requestParameters['specificDaySinceDayModelRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DayModelResponseFromJSON(jsonValue));
    }

    /**
     * Update a specific days since new day model
     */
    async updateSpecificDaySinceNewDayModel(requestParameters: UpdateSpecificDaySinceNewDayModelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DayModelResponse> {
        const response = await this.updateSpecificDaySinceNewDayModelRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a week model
     */
    async updateWeekModelRaw(requestParameters: UpdateWeekModelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling updateWeekModel().'
            );
        }

        if (requestParameters['weekmodelId'] == null) {
            throw new runtime.RequiredError(
                'weekmodelId',
                'Required parameter "weekmodelId" was null or undefined when calling updateWeekModel().'
            );
        }

        if (requestParameters['weekModelRequest'] == null) {
            throw new runtime.RequiredError(
                'weekModelRequest',
                'Required parameter "weekModelRequest" was null or undefined when calling updateWeekModel().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/settings/week-model/{weekmodel_id}`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))).replace(`{${"weekmodel_id"}}`, encodeURIComponent(String(requestParameters['weekmodelId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: WeekModelRequestToJSON(requestParameters['weekModelRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update a week model
     */
    async updateWeekModel(requestParameters: UpdateWeekModelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateWeekModelRaw(requestParameters, initOverrides);
    }

    /**
     * Update week model of timeslot by id
     */
    async updateWeekModelTimeslotByIdRaw(requestParameters: UpdateWeekModelTimeslotByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TimeslotResponse>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling updateWeekModelTimeslotById().'
            );
        }

        if (requestParameters['timeslotId'] == null) {
            throw new runtime.RequiredError(
                'timeslotId',
                'Required parameter "timeslotId" was null or undefined when calling updateWeekModelTimeslotById().'
            );
        }

        if (requestParameters['weekModelIdsRequest'] == null) {
            throw new runtime.RequiredError(
                'weekModelIdsRequest',
                'Required parameter "weekModelIdsRequest" was null or undefined when calling updateWeekModelTimeslotById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['doctorId'] != null) {
            queryParameters['doctor_id'] = requestParameters['doctorId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/settings/timeslots/{timeslot_id}/week-model`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))).replace(`{${"timeslot_id"}}`, encodeURIComponent(String(requestParameters['timeslotId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: WeekModelIdsRequestToJSON(requestParameters['weekModelIdsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TimeslotResponseFromJSON(jsonValue));
    }

    /**
     * Update week model of timeslot by id
     */
    async updateWeekModelTimeslotById(requestParameters: UpdateWeekModelTimeslotByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TimeslotResponse> {
        const response = await this.updateWeekModelTimeslotByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update the name of week models
     */
    async updateWeekModelsNameRaw(requestParameters: UpdateWeekModelsNameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WeekModelByNameResponse>>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling updateWeekModelsName().'
            );
        }

        if (requestParameters['weekModelUpdateNameRequest'] == null) {
            throw new runtime.RequiredError(
                'weekModelUpdateNameRequest',
                'Required parameter "weekModelUpdateNameRequest" was null or undefined when calling updateWeekModelsName().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['doctorId'] != null) {
            queryParameters['doctor_id'] = requestParameters['doctorId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/settings/week-model-name`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: WeekModelUpdateNameRequestToJSON(requestParameters['weekModelUpdateNameRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WeekModelByNameResponseFromJSON));
    }

    /**
     * Update the name of week models
     */
    async updateWeekModelsName(requestParameters: UpdateWeekModelsNameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WeekModelByNameResponse>> {
        const response = await this.updateWeekModelsNameRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
